import { Scrollbar, Navigation } from 'swiper/modules';
import Swiper from 'swiper';

export default function initProductSlider() {
  Alpine.data('productSlider', () => ({
    swiper: null as Swiper | null,
    init() {
      const slider = this.$el.querySelector('.product-swiper') as HTMLElement;
      const { slideCountDesktop, slideCountMobile } = slider.dataset;
      const slidesPerViewDesktop = slideCountDesktop && slideCountDesktop !== 'auto' ? Number(slideCountDesktop) : 'auto';
      const slidesPerViewMobile = slideCountMobile && slideCountMobile !== 'auto' ? Number(slideCountMobile) : 'auto';
      if (slider) {
        this.swiper = new Swiper(slider, {
          modules: [Scrollbar, Navigation],
          slidesPerView: 'auto',
          scrollbar: {
            el: `#${this.$el.id} .product-swiper-scrollbar`,
            draggable: true,
            dragClass: 'swiper-scrollbar-drag bg-gray-600! rounded-none! cursor-grab',
          },
          navigation: {
            nextEl: `#${this.$el.id} .product-swiper-button-next`,
            prevEl: `#${this.$el.id} .product-swiper-button-prev`,
            disabledClass: 'opacity-40 cursor-not-allowed pointer-events-none',
          },
          spaceBetween: 16,
          breakpoints: {
            640: {
              slidesPerView: 2,
              spaceBetween: 20,
            },
            768: {
              slidesPerView: slidesPerViewMobile,
            },
            1024: {
              slidesPerView: slidesPerViewDesktop,
            },
          },
        });
      }
    },
  }));
}
